import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { getRolName, getRolUitleg, RRol } from '@cumlaude/service-contract';

export interface RolSwitcherDialogData {
	rollen: RRol[];
	activeRol: RRol | undefined;
}

@Component({
	selector: 'app-rol-switcher-dialog',
	templateUrl: './rol-switcher-dialog.component.html',
	styleUrls: ['./rol-switcher-dialog.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RolSwitcherDialogComponent {
	dialogRef = inject<DialogRef<RRol>>(DialogRef);
	protected data = inject<RolSwitcherDialogData>(DIALOG_DATA);

	protected readonly getRolName = getRolName;
	protected readonly getRolUitleg = getRolUitleg;

	isActief(rol: RRol): boolean {
		return rol === this.data.activeRol;
	}

	kiesRol(rol: RRol) {
		this.dialogRef.close(rol);
	}
}
